import MuiList, { ListProps as MuiListProps } from '@mui/material/List';
import * as React from 'react';

export interface ListProps extends MuiListProps {}

export const List = (props: ListProps) => {
  return <MuiList {...props} />;
};
